import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-chat-tool-placeholder',
  templateUrl: './chat-tool-placeholder.component.html'
})
export class ChatToolPlaceholderComponent {
  @Input() toolName!: string;
}
